<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'teal'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.add')"
        :icon="error ? 'mdi-alert' : 'mdi-plus-circle-outline'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnAdd',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>